<template>
    <section id="second-hero-section" class="my-20">
        <div 
            class="flex flex-col md:flex-row mx-5 md:px-10 md:mx-10" 
            :class="context.isDarkMode ? 'text-second-color' : 'text-third-color'"
        >
            <div class="w-full md:w-1/2">
                <img 
                    class="mx-auto"
                    width="700"
                    :src="require(`@/assets/images/colossus_${context.isDarkMode ? 'dark' : 'light'}.png`)"
                >
            </div>

            <div class="w-full md:w-1/2 flex flex-col justify-center text-center md:text-right">
                <h1 class="text-2xl lg:text-4xl mb-5 font-thin">
                    {{ translationHandler.translate('dominate the digital world like a giant', 'ucfirst') }}
                </h1>

                <p class="text-lg font-light" :class="context.isDarkMode ? 'text-main-gray' : 'text-semidark-silver'">
                    {{ translationHandler.translate('with a powerful online presence, your brand becomes an unstoppable force. our services transform your idea into a robust digital platform, ensuring you achieve extraordinary results', 'ucfirst') }}.
                </p>
            </div>
        </div>
    </section>
</template>

<script setup>
    import translationHandler from '@/composables/handlers/TranslationHandler';
    import { useContextStore } from '@/stores/context';

    const context = useContextStore();


</script>